import React from 'react';
import { Tabs as MuiTabs } from '@mui/material';
import clsx from 'clsx';
import { TabsComponent, TabsProps, tabsClasses } from './types';

export const Tabs: TabsComponent = (props: TabsProps) => {
  const {
    children, divider, condensed, className, color = 'secondary', ...rest
  } = props;

  return (
    <MuiTabs
      {...rest}
      textColor={color}
      indicatorColor={color}
      className={clsx(
        className,
        {
          [tabsClasses.divider]: Boolean(divider),
          [tabsClasses.condensed]: Boolean(condensed),
        },
      )}
    >
      {children}
    </MuiTabs>
  );
};
